export default __webpack_public_path__ + "static/media/puppyFemaleWhite.9a10793c.jpg";